import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SelectedRowContextProps {
  selectedSchemeRow: number | null;
  setSchemeRow: (index: number | null) => void;
}

const SelectedSchemeRowContext = createContext<SelectedRowContextProps | undefined>(undefined);

interface SelectedRowProviderProps {
  children: ReactNode;
}

export const SelectedSchemeRowProvider: React.FC<SelectedRowProviderProps> = ({ children }) => {

  const [selectedSchemeRow, setSelectedSchemeRow] = useState<number | null>(
    JSON.parse(localStorage?.getItem('selectedSchemeRow') || 'null')
  );

  const setSchemeRow = (index: number | null) => {
    setSelectedSchemeRow(index);
  };

  useEffect(() => {
    if (selectedSchemeRow !== null) {
      localStorage?.setItem('selectedSchemeRow', JSON.stringify(selectedSchemeRow));
    } else {
      localStorage?.removeItem('selectedSchemeRow');
    }
  }, [selectedSchemeRow]);

  const contextValue: SelectedRowContextProps = {
    selectedSchemeRow,
    setSchemeRow,
  };

  return (
    <SelectedSchemeRowContext.Provider value={contextValue}>
      {children}
    </SelectedSchemeRowContext.Provider>
  );
};

export const useSelectedSchemeRow = (): SelectedRowContextProps => {
  const context = useContext(SelectedSchemeRowContext);
  if (!context) {
    throw new Error('useSelectedSchemeRow must be used within a SelectedSchemeRowProvider');
  }
  return context;
};
